import React, { Fragment, useEffect, } from 'react';
import { Button, } from 'reactstrap';
import { pickBy, isEmpty, groupBy, get, pick, omit, uniqBy, keyBy, } from 'lodash';
import { format as formatDate, addMonths, } from 'date-fns';
import { toast, } from 'react-toastify';
import { useCounter, useToggle, } from 'react-use';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import numeral from 'numeral';

import firebase, { functions } from '../../firebase';
import { idWithTenant, } from '../../shared/util';
import { boxSizes, } from '../../shared/config';
import { adminFields, } from '../../shared/models/product';
import { cmSizes, } from '../../shared/models/amazonProduct';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import useDocumentSubscription from '../hooks/useDocumentSubscription';
import useCollectionsFetch from '../hooks/useCollectionsFetch';
import useQueryParams from '../hooks/useQueryParams';
import AdminPage from '../hocs/AdminPage';
import ModelFormModal from '../modals/ModelFormModal';
import QuerySelector from '../QuerySelector';
import EditButton from '../EditButton';
import ProgressButton from '../ProgressButton';
import QueryInput from '../QueryInput';
import ModalButton from '../ModalButton';

const { keys, entries } = Object;
const db = firebase.firestore();
const tenantsRef = db.collection('tenants');
const productsRef = db.collectionGroup('products');

export default AdminPage(function AdminNoSizeProducts (props) {
  const useCounts = useCollectionSubscription(db.collectionGroup('useCounts').where('yearMonth', '==', formatDate(addMonths(new Date(), -1), 'yyyyMM')));
  const prevMonthStoragedProductIds = useCounts.flatMap((useCount) => {
    const tenantId = useCount.ref.parent.parent.id;
    return Object.values(useCount.storageDays).flatMap(_ => keys(pickBy(_, _ => _ > 0))).map(_ => [tenantId, _].join('-'));
  });
  const locations = useCollectionSubscription(db.collection('locations'));
  const locationsById = keyBy(locations, 'id');
  const products = useCollectionSubscription(productsRef.where('shippingSize', '==', null).where('isAmazonProduct', '==', false));
  const caseAmazonProducts = useCollectionSubscription(productsRef.where('shippingSize', '==', null).where('isAmazonProduct', '==', true).where('isCase', '==', true));
  const { keyword = '', } = useQueryParams();
  const filteredProducts = [...products, ...caseAmazonProducts]
    .filter(_ => !_.isSet)
    .filter(_ => prevMonthStoragedProductIds.includes(idWithTenant(_.ref)))
    .filter(_ => [idWithTenant(_.ref), _.sku, _.asin, _.name].some(_ => _?.includes(keyword)));
  const displayProducts = filteredProducts.slice(0, 500);
  const inventories = useCollectionsFetch(displayProducts.map(_ => db.collection('inventories').where('tenantId', '==', _.ref.parent.parent.id).where('productId', '==', _.id).where('status', '==', 'shelved')), [displayProducts.map(_ => _.id).join(',')]);
  const inventoriesByProductId = keyBy(inventories, _ => [_.tenantId, _.productId].join('-'));

  return (
    <div className="admin-receivingRequests container-fluid">
      <div className="p-4 bg-white my-4">
        <div className="d-flex justify-content-center mb-3">
          <h4>サイズ未設定商品</h4>
        </div>
        <div className="d-flex align-items-start gap-1">
          <div style={{ width: 300 }}>
            <QueryInput width={null} paramName="keyword" label="フリーワード" />
          </div>
        </div>
        <div className="mt-3">
          {displayProducts.length} / {filteredProducts.length}
        </div>
        <div className="mt-1 overflow-scroll position-relative" style={{ zIndex: 0 }}>
          {
            [...products, ...caseAmazonProducts].length > 0 ? (
              <table className="table sticky-table table-bordered">
                <thead className="thead-light text-center">
                  <tr className="text-nowrap">
                    <th style={{ minWidth: 150 }}>ID</th>
                    <th style={{ minWidth: 150 }}>SKU</th>
                    <th style={{ minWidth: 150 }}>ASIN</th>
                    <th style={{ minWidth: 200 }}>商品名</th>
                    <th style={{ minWidth: 100 }}>在庫数</th>
                    <th style={{ minWidth: 100 }}>販売不可数</th>
                    <th style={{ minWidth: 200 }}>サイズ</th>
                    <th style={{ minWidth: 150 }}>ロケーション</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    displayProducts.map((product) => {
                      const { id, ref, isAmazonProduct, name, sku, asin, goodInventory, ngInventory, fnskuError, amazonProduct, shippingSize, } = product;
                      const inventory = inventoriesByProductId[idWithTenant(ref)];
                      const location = locationsById[inventory?.locationId];

                      return (
                        <tr key={idWithTenant(ref)}>
                          <td>
                            {idWithTenant(ref)}
                          </td>
                          <td>
                            {sku}
                          </td>
                          <td>
                            {asin}
                          </td>
                          <td>
                            {name}
                          </td>
                          <td className="text-right">
                            {numeral(goodInventory).format()}
                          </td>
                          <td className="text-right">
                            {numeral(ngInventory).format()}
                          </td>
                          <td>
                            {
                              shippingSize ? (
                                boxSizes[shippingSize]?.label
                              ) : (
                                amazonProduct && cmSizes(amazonProduct).map(_ => Math.round(_) + 'cm').join(' x ')
                              )
                            }
                          </td>
                          <td>
                            {location?.name}
                          </td>
                          <td className="text-right text-nowrap">
                            <div className="d-flex gap-1">
                              <EditButton itemRef={ref} FormModal={ModelFormModal} formProps={{ title: '商品 編集', fields: pick(adminFields(), 'shippingSize'), }} />
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
            ) : (
              <div>
                No Data
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
});
